export { default } from "./ResponsiveContainer";



// WEBPACK FOOTER //
// ./src/design-system/layout/ResponsiveContainer/index.jsx